import React, { Fragment } from "react";
import cx from "classnames";
import { connect } from "react-redux";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { FaBars } from 'react-icons/fa';
import 'react-toastify/dist/ReactToastify.css';
import HeaderLogo from "../AppLogo";
import V1LOGO from "../../assets/images/V1LOGO.png";
import dhanashakthi from "../../assets/images/dhanashakthi.png";
import { Dropdown } from 'react-bootstrap';

import API_URLS from "../../summaryapi/apiUrls";

const CompanyDropdown = ({ companies, selectedCompany, setSelectedCompany }) => (
  <Dropdown className="mr-3">
    <Dropdown.Toggle
      variant="light"
      size="sm"
      style={{
        minWidth: '180px',
        backgroundColor: '#fff',
        borderColor: 'rgba(255, 255, 255, 0.3)',
        color: '#333',
      }}
    >
      {selectedCompany
        ? companies.find(c => c.guid === selectedCompany)?.company_name
        : 'Select Company'}
    </Dropdown.Toggle>

    <Dropdown.Menu style={{ maxHeight: '300px', overflowY: 'auto' }}>
      {companies.map(company => (
        <Dropdown.Item
          key={company.guid}
          active={selectedCompany === company.guid}
          onClick={() => setSelectedCompany(company.guid)}
          style={{ fontSize: '12px' }}
        >
          {company.company_name}
        </Dropdown.Item>
      ))}
    </Dropdown.Menu>
  </Dropdown>
);








class Header extends React.Component {
constructor(props) {
    super(props);
    this.state = {
      activeSearch: false,
      isMobileMenuOpen: false,
      companies: [],
      selectedCompany: null
    };
  }

  componentDidMount() {
    this.fetchCompanies();
    const storedCompany = localStorage.getItem('selectedCompany');
    if (storedCompany) {
      this.setState({ selectedCompany: storedCompany });
    }
  }

  fetchCompanies = async () => {
    try {
      const response = await fetch(API_URLS.getActivecompany.url);
      const data = await response.json();
      if (data.status) {
        this.setState({ companies: data.data });
        // Set the first company as default if none is selected
        if (!this.state.selectedCompany && data.data.length > 0) {
          this.setSelectedCompany(data.data[0].guid);
        }
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  setSelectedCompany = (companyGuid) => {
    this.setState({ selectedCompany: companyGuid });
    localStorage.setItem('selectedCompany', companyGuid);
    // You might want to trigger any company change effects here
  };


  toggleMobileMenu = () => {
    this.setState((prevState) => ({
      isMobileMenuOpen: !prevState.isMobileMenuOpen,
    }));
  };

  render() {
    let { enableMobileMenuSmall } = this.props;
const adminMode = sessionStorage.getItem("adminMode") ? atob(sessionStorage.getItem("adminMode")) : null;
    const { companies, selectedCompany } = this.state;
    return (
      <Fragment>
        <TransitionGroup>
          <CSSTransition 
            component="div"
            className={cx("app-header")}
            appear={true} 
            style={{ background: "linear-gradient(135deg,rgb(172, 37, 44),rgb(235, 45, 64),rgb(172, 35, 35))" }} 
            timeout={1500} 
            enter={false} 
            exit={false}
          >
<div style={{ 
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  padding: '15px 20px',
  position: 'relative'
}}>

  <div style={{
    position: 'center',
    top: '50%',
    transform: 'translateY(-0%)'
  }}>

  </div>


              {/* Centered Logo and Title */}
              <div style={{
                position: 'absolute',
                left: '40%',
                transform: 'translateX(-50%)',
                display: 'flex',
                alignItems: 'center'
              }}>
                  <img 
                  src={dhanashakthi} 
                  alt="Dhana Shankthi" 
                  style={{ 
                    width: '160px', 
                    height: '40px', 
      
                  }} 
                />


                <h3 className="admin-dashboard-title" style={{ 
                  margin: 0,
                  color: '#fff', // Ensure text is visible on any background
                  textShadow: '0 1px 2px rgba(0,0,0,0.3)' // Add shadow for better visibility
                }}>
                  {adminMode === "Admin" 
                    ? "" 
                    : adminMode === "Employee" 
                      ? "" 
                      : `${adminMode} Admin Dashboard`}










                </h3>
     </div>


<div style={{ 
  position: 'absolute',
  left: '50%',
  transform: 'translateX(120px)', // Push right from center
  display: 'flex',
  alignItems: 'center'
}}>
  <CompanyDropdown 
    companies={companies.filter(c => c.guid && c.guid.trim() !== "")}
    selectedCompany={selectedCompany}
    setSelectedCompany={this.setSelectedCompany}
  />
</div>

         
            </div>
          </CSSTransition>
        </TransitionGroup>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Header);